<template>
<div>
<div>
 <main  tabindex="-1" id="okta-sign-in" class="auth-container main-container can-remove-beacon" style="">
   <div class="okta-sign-in-header auth-header">
    <h1>
       <img  src="./../assets/qrp-abbreviated-color.svg" class="auth-org-logo" alt="qrp-auth logo logo" aria-label="qrp-auth logo logo">
    </h1>
    <div data-type="beacon-container" class="beacon-container" style="transform: scale(1, 1); text-indent: 1px;">
        <div class="js-security-beacon">
        <div class="beacon-blank">
            <div class="radial-progress-bar" style="clip: rect(0px, 96px, 96px, 48px);">
            <div class="circle left" style="transform: rotate(0deg); text-indent: 1px;">
            </div><div class="circle right" style="transform: rotate(0deg); text-indent: 1px;">
                    </div>
        </div>
        </div>
    <div aria-live="polite" role="img" class="bg-helper  auth-beacon auth-beacon-security displayDefaultImg" data-se="security-beacon">
     <div class="okta-sign-in-beacon-border js-auth-beacon-border auth-beacon-border">
    </div>
    </div>
    </div></div></div>
    <div class="auth-content">
     <div class="auth-content-inner">
        <p class="fontForLogin" style="text-align: center;">User is inactive</p>
        <p class="fontForLogin">Please contact your administrator or close your browser to sign in as a different user.</p>
          <!-- <button type="submit" class="button btn btn-primary" @click.prevent="closeSession">Sign In</button> -->
     </div>
     </div>
 </main>
</div>
</div>
</template>
<script>
/* eslint-disable */
import User from '../services/User';
import axios from '../axios-config';
import Vue from 'vue';

export default {
 props: ['NotActiveUser'],
  data() {
    return {
      count: 0,
      showLoader: true,
    };
  },
  mounted() {
    this.hideLoader()
  },
  async created() {
  //console.log('NotActiveUser',this.$route.params.NotActiveUser);
  // sessionStorage.clear();
  // localStorage.clear();
  // document.cookie = 'okta-oauth-redirect-params' +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  // document.cookie = 'okta-oauth-state' +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  // document.cookie = 'okta-oauth-nonce' +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  //  document.cookie = 'sid' +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
 },
  methods: {
    async closeSession()
    {
     //  this.$security.getsession();
     // this.$security.closeMe();
      //window.location.reload(true);
     // this.$auth.logout('/').catch( err => console.log(err) );
     // window.location.replace('/');
     // window.open("http://localhost:8080/");
     },    
    hideLoader() {
    // using setTimeout to programmatically hide loader
    setTimeout(() => {
      this.showLoader = false
    }, 5000)
    },
 }
};
</script>
<style scoped>
  #qrp-logo{
    display: block;
    width: 100%;
    max-width: 130px;
    height: inherit !important;
    margin:0 auto;
  }
  #logo {
	vertical-align:middle;
}
.navbar-brand span {
	font-size:2rem;
	line-height:1.2;
	font-weight: 200;
	display:inline-block;
	vertical-align:middle;
	padding:0 0 0 15px;
}
.navbar-brand b {
	display:block;
	font-size:50%;
	line-height:1;
}
.navbar-nav {
	margin-left:auto;
}
#okta-sign-in.auth-container.main-container {
    background-color: #fff;
    border-color: #ddd #ddd #d8d8d8;
    box-shadow: 0 2px 0 hsl(0deg 0% 69% / 12%);
}
#okta-sign-in {
    font-family: proxima nova,montserrat-okta,Arial,Helvetica,sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.4;
    background-color: #f9f9f9;
    color: #6e6e78;
    position: relative;
    overflow: auto;
    border-radius: 3px;
    border-style: solid;
    border-width: 1px;
    height: auto;
    margin: 100px auto 8px;
    width: 400px;
    min-width: 300px;
}
#okta-sign-in .auth-header {
    padding: 30px 90px 75px;
    position: relative;
    border-bottom: 1px solid #ddd;
    z-index: 10;
    -moz-transition: padding-bottom .4s;
    -webkit-transition: padding-bottom .4s;
    transition: padding-bottom .4s;
}
#okta-sign-in .beacon-blank {
    background-image: none;
    background-color: transparent;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
}
#okta-sign-in .auth-beacon {
    position: absolute;
    border-radius: 50%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #fff;
    background-repeat: no-repeat;
    background-position: 50%;
    background-size: cover;
    background-clip: content-box;
    color: #fff;
    box-shadow: 0 0 0 15px;
}
#okta-sign-in .auth-beacon-border {
    position: absolute;
    border: 2px solid #a7a7a7;
    border-radius: 50%;
    bottom: -5px;
    left: -5px;
    right: -5px;
    top: -5px;
}
#okta-sign-in.auth-container .okta-sign-in-beacon-border {
    border-color: #a7a7a7;
}
#okta-sign-in .auth-content {
    padding: 60px 42px 20px;
    -moz-transition: padding-top .4s;
    -webkit-transition: padding-top .4s;
    transition: padding-top .4s;
}
#okta-sign-in .auth-content .auth-content-inner {
    position: relative;
}
#okta-sign-in.auth-container .okta-sign-in-header {
   border-bottom-color: #ddd; 
}
#okta-sign-in.auth-container .okta-sign-in-header {
     color: #5e5e5e; 
}
p.fontForLogin{
 font-size: 15px;
 color: #5e5e5e; 
 text-align:center;
}

#okta-sign-in .auth-org-logo {
    display: block;
    margin: 0 auto;
    max-width: 200px;
    max-height: 40px;
}
#okta-sign-in .beacon-container {
    position: absolute;
    bottom: -42px;
    right: 0;
    left: 0;
    margin: auto;
    width: 85px;
    height: 85px;
    -webkit-transform: scale(0);
    transform: scale(0);
}
.displayDefaultImg{
  background: url("./../assets/default.svg") no-repeat;

}
#okta-sign-in .o-form-head {
    font-size: 15px;
    line-height: 1.5;
    margin-top: 10px;
    text-align: center;
    text-transform: none;
    font-weight: 600;
}
#okta-sign-in .o-form-button-bar {
    background: transparent;
    border: none;
    padding: 0 0 25px;
    border-radius: 0;
    box-shadow: none;
}
#okta-sign-in .o-form-button-bar .button {
    display: block;
    width: 100%;
    height: 50px;
}

.spin {
  position: relative;
  display: inline-block;
  width: 90px;
  height: 90px;
  border: 2px solid #34495e;
  border-radius: 100%;
  animation: spin 0.75s infinite linear;
}

.spin::before,
.spin::after {
  left: -2px;
  top: -2px;
  display: none;
  position: absolute;
  content: '';
  width: inherit;
  height: inherit;
  border: inherit;
  border-radius: inherit;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.spinner,
.spinner::before,
.spinner::after {
  display: inline-block;
  border-color: transparent;
  border-top-color: #0073b2;
  animation-duration: 1.2s;
}

.spinner::before {
  transform: rotate(120deg);
}

.spinner::after {
  transform: rotate(240deg);
}

@media (max-width:480px) {
  .spin {
    width: 270px;
    height: 270px;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/LoggedOut.vue?3a0f2e78